import { useState, type FormEvent, type FormHTMLAttributes, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { provjeriObrazac, zakonUPoruke, type NevaljanoPolje } from './zakonForme'

/**
 * OBRAZAC KOJI NE GUTA SUBMIT — jedino mjesto na kojem `<form>` živi izvan
 * dijaloga (dotjerivanje-10 §1; zakon i obrazloženje: `components/zakonForme.ts`,
 * dijalog: `components/FormModal.tsx`).
 *
 * Radi jednu stvar više od golog `<form>`-a: nativna provjera je isključena
 * (`noValidate`), pa `naSlanje` dobiva samo obrazac koji je PROŠAO — a onaj koji
 * nije dobiva crveni rub na polju (CSS po `data-provjeren`), fokus na prvom palom
 * i rečenicu koja imenuje polje i pravilo. Gola `<form>` na istom mjestu bila je
 * obrazac na kojem se "Spremi" povremeno ne događa i nitko ne zna zašto.
 *
 * Popis stoji na DNU: gumb je ono što je korisnik upravo pritisnuo, pa mu je
 * odgovor pod prstom — a polje na koje se odnosi je u istom trenutku fokusirano.
 *
 * **Dvije podloge, jedan zakon** (§17): `noir` je gost i vozač, `paper` konzola.
 * Razlikuje se boja poruke i ništa više.
 */
export function Obrazac({
  naSlanje,
  ton = 'paper',
  className,
  children,
  ...ostalo
}: {
  naSlanje: (dogadaj: FormEvent<HTMLFormElement>) => void
  ton?: 'noir' | 'paper'
  className?: string
  children: ReactNode
} & Omit<FormHTMLAttributes<HTMLFormElement>, 'onSubmit' | 'className' | 'children'>) {
  const { t } = useTranslation()
  const [pala, postaviPalu] = useState<readonly NevaljanoPolje[]>([])

  return (
    <form
      noValidate
      className={className}
      onSubmit={(dogadaj) => {
        dogadaj.preventDefault()

        const nevaljana = provjeriObrazac(dogadaj.currentTarget)

        postaviPalu(nevaljana)

        if (nevaljana.length > 0) return

        naSlanje(dogadaj)
      }}
      {...ostalo}
    >
      {children}

      {pala.length > 0 ? (
        <ul
          role="alert"
          /*
            `basis-full`: obrazac smije biti i vodoravan red polja (pretraga po
            sobi, filtri izvještaja), a poruka koja se ugura između dva polja nije
            poruka nego još jedno polje.
          */
          className={
            ton === 'noir'
              ? 'mt-3 flex basis-full flex-col gap-1 text-xs text-champagne'
              : 'mt-3 flex basis-full flex-col gap-1 text-sm font-medium text-bad-tx'
          }
        >
          {zakonUPoruke(t, pala).map((stavka, redni) => (
            <li key={`${redni}-${stavka.polje}`}>
              {stavka.oznaka ? `${stavka.oznaka} — ${stavka.poruka}` : stavka.poruka}
            </li>
          ))}
        </ul>
      ) : null}
    </form>
  )
}
